// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HomeInstitution_home-institution__YkyI6 {
  display: flex;
  padding: 100px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 48px;
  align-self: stretch;
  background: var(--background-color-2);
}
.HomeInstitution_home-institution__YkyI6 .HomeInstitution_home-institution__container__tM7Pm {
  display: flex;
  align-items: center;
  gap: 48px;
  align-self: stretch;
}
.HomeInstitution_home-institution__YkyI6 .HomeInstitution_home-institution__left__2FIWf {
  display: flex;
  flex: 3 1;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 32px;
}
.HomeInstitution_home-institution__YkyI6 .HomeInstitution_home-institution__left--title__J3zGM {
  color: var(--accent-color);
  font-size: 32px;
}
.HomeInstitution_home-institution__YkyI6 .HomeInstitution_home-institution__left--description__JUarX {
  color: var(--text-1);
}
.HomeInstitution_home-institution__YkyI6 .HomeInstitution_home-institution__left--button__O83-p {
  background-color: var(--accent-color);
  text-transform: initial;
}
.HomeInstitution_home-institution__YkyI6 .HomeInstitution_home-institution__left--button__O83-p svg {
  fill: white;
}
.HomeInstitution_home-institution__YkyI6 .HomeInstitution_home-institution__right__NIBnD {
  flex: 4 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}
.HomeInstitution_home-institution__YkyI6 .HomeInstitution_home-institution__right--image__mWvH7 {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.HomeInstitution_home-institution__YkyI6 .HomeInstitution_home-institution__right--image__container__mxx9T {
  aspect-ratio: 679/536;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/Home/Components/HomeInstitution/HomeInstitution.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,qCAAA;AACF;AAEI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAAN;AAEI;EACE,aAAA;EACA,SAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;AAAN;AAEM;EACE,0BAAA;EACA,eAAA;AAAR;AAGM;EACE,oBAAA;AADR;AAIM;EACE,qCAAA;EACA,uBAAA;AAFR;AAIQ;EACE,WAAA;AAFV;AAMI;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;AAJN;AAMM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAJR;AAMQ;EACE,qBAAA;AAJV","sourcesContent":[".home-institution {\n  display: flex;\n  padding: 100px 24px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 48px;\n  align-self: stretch;\n  background: var(--background-color-2);\n\n  .home-institution {\n    &__container {\n      display: flex;\n      align-items: center;\n      gap: 48px;\n      align-self: stretch;\n    }\n    &__left {\n      display: flex;\n      flex: 3;\n      flex-direction: column;\n      justify-content: center;\n      align-items: flex-start;\n      gap: 32px;\n\n      &--title {\n        color: var(--accent-color);\n        font-size: 32px;\n      }\n\n      &--description {\n        color: var(--text-1);\n      }\n\n      &--button {\n        background-color: var(--accent-color);\n        text-transform: initial;\n\n        svg {\n          fill: white;\n        }\n      }\n    }\n    &__right {\n      flex: 4;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: flex-start;\n\n      &--image {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n\n        &__container {\n          aspect-ratio: 679/536;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"home-institution": `HomeInstitution_home-institution__YkyI6`,
	"home-institution__container": `HomeInstitution_home-institution__container__tM7Pm`,
	"home-institution__left": `HomeInstitution_home-institution__left__2FIWf`,
	"home-institution__left--title": `HomeInstitution_home-institution__left--title__J3zGM`,
	"home-institution__left--description": `HomeInstitution_home-institution__left--description__JUarX`,
	"home-institution__left--button": `HomeInstitution_home-institution__left--button__O83-p`,
	"home-institution__right": `HomeInstitution_home-institution__right__NIBnD`,
	"home-institution__right--image": `HomeInstitution_home-institution__right--image__mWvH7`,
	"home-institution__right--image__container": `HomeInstitution_home-institution__right--image__container__mxx9T`
};
export default ___CSS_LOADER_EXPORT___;
